import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-rewind",
  "use": "icon-rewind-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-rewind\" id=\"icon-rewind\"><polygon points=\"11 19 2 12 11 5 11 19\" /><polygon points=\"22 19 13 12 22 5 22 19\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol